export default __webpack_public_path__ + "static/media/clinic_bg_image.3d9210a0.jpg";